import styled from '@emotion/styled';

/**
 * Next/Previous Navigation Buttons
 * Updated to match Figma design specifications
 */
export const StyledNextPrevious = styled('div')`
  margin: 0;
  padding: 0;
  width: auto;
  display: grid;
  grid-template-rows: auto;
  column-gap: var(--gap-5x, 24px);
  grid-template-columns: calc(50% - 12px) calc(50% - 12px);

  .previousBtn,
  .nextBtn {
    cursor: pointer;
    margin: 0;
    padding: 0;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    place-self: stretch;
    border-radius: var(--radius-md, 6px);
    border: 1px solid var(--color-border);
    transition: all var(--transition-fast, 0.15s ease);
    box-shadow: var(--shadow-header);
    text-decoration: none;
    color: var(--color-info-secondary);
  }

  .previousBtn:hover,
  .nextBtn:hover {
    text-decoration: none;
    border-color: var(--color-primary, #04b17d);
    box-shadow: var(--shadow-card);
  }

  .previousBtn:hover .leftArrow,
  .nextBtn:hover .rightArrow {
    color: var(--color-primary, #04b17d);
  }

  .leftArrow,
  .rightArrow {
    display: flex;
    margin: 0;
    color: var(--color-info-tertiary);
    flex: 0 0 auto;
    font-size: 24px;
    transition: color var(--transition-fast, 0.15s ease);
    padding: var(--gap-3x, 16px);
  }

  .nextPreviousTitle {
    display: block;
    margin: 0;
    padding: 0;
    transition: color var(--transition-fast, 0.15s ease);
  }

  .nextPreviousTitle span {
    font-family: var(--font-family-primary, 'Inter', sans-serif);
    font-size: var(--font-size-base, 16px);
    line-height: 1.5;
    font-weight: 500;
    color: var(--color-info-secondary);
  }

  @media (max-width: 767px) {
    display: block;
    padding: 0 var(--gap-3x, 15px);

    .previousBtn {
      margin-bottom: var(--gap-4x, 20px);
    }
  }
`;
